import { render } from "./CheckTicketExtraRequest.vue?vue&type=template&id=462bb068"
import script from "./CheckTicketExtraRequest.vue?vue&type=script&lang=js"
export * from "./CheckTicketExtraRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__